// The report generator's server endpoints (Web.Api ReportAgentController). The model is only
// ever reached through resolve(); everything else runs a report with settings the server
// checks again on every call.
import axios from 'axios';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';

const BASE = 'reportagent';

export async function getTools() {
    const { data } = await axios.get(`${BASE}/tools`);
    return data;
}

export async function resolve(question, locationId) {
    const { data } = await axios.post(`${BASE}/resolve`, { question, locationId });
    return data;
}

export async function run(request) {
    const { data } = await axios.post(`${BASE}/run`, request);
    return data;
}

// The server names the file; the fallback covers a Content-Disposition the browser cannot read.
export async function exportReport(request) {
    const response = await axios.post(`${BASE}/export`, request, { responseType: 'blob' });
    const format = (request.format || 'csv').toLowerCase();
    const type = format === 'pdf' ? 'application/pdf' : 'application/csv';
    const fileName = fileNameFrom(response.headers?.['content-disposition']) || `${request.toolId}.${format}`;
    downloadFileToBrowser(response.data, fileName, type);
}

export async function listReports() {
    const { data } = await axios.get(`${BASE}/reports`);
    return data;
}

export async function saveReport(body) {
    const { data } = await axios.post(`${BASE}/reports`, body);
    return data;
}

export async function updateReport(id, body) {
    const { data } = await axios.put(`${BASE}/reports/${id}`, body);
    return data;
}

export async function deleteReport(id) {
    await axios.delete(`${BASE}/reports/${id}`);
}

export async function runSaved(id, body) {
    const { data } = await axios.post(`${BASE}/reports/${id}/run`, body);
    return data;
}

export async function listActivity(paging) {
    const { data } = await axios.get(`${BASE}/activity`, { params: paging });
    return data;
}

function fileNameFrom(contentDisposition) {
    if (!contentDisposition)
        return null;

    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(contentDisposition);
    return match ? decodeURIComponent(match[1]) : null;
}
